var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.items,"no-data-text":"No printers found","placeholder":"Default printer","disabled":_vm.disabled,"hide-details":"","outlined":"","dense":"","background-color":"#FFFFFF"},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }